import React from "react";
import {FormSectionElements} from "src/entities/formTemplateDataType";
import classNames from 'classnames';
import {LiveValidationErrMsg} from "../../live-validation-errMsg/LiveValidationErrMsg";
import FormValidationUtils from "../../../utilities/FormValidationUtils";
import {displayField, getRootComponent} from "../../../utilities/ElementUtils";
import {ButtonComponent} from ".././ButtonComponent";
import { getEnvVar } from "../../../config/RuntimeConfig";

interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
  callbackStepIndex: (index: number) => void;
}

interface State {
 
}

export class BXPCancelWithExitComponent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    // Set up StepperScript and ClassName once in constructor for clarity
    const field = this.props.field;
    field.StepperScript = `(func)=>{
      const customJSFunc = eval(func);
      customJSFunc(1);
    }`;
    field.ClassName = "ontario-button ontario-button--primary";
  }
render() {
    let field = this.props.field;
    if(!field.Visible) return null;
    let editable = this.props.editable;
    let labelControlArray = this.props.labelControlArray;
    let requiredField = this.props.requiredField;
    let controlArray = [];
    // Support English and French titles
    let title = this.props.isEng ? this.props.field.ENUTitle : this.props.field.FRATitle;
    const display = displayField(field);

    if (editable) {
      controlArray.push(
        <div
          key={`div_${field.Datatype}_${field.Id}`}
          id={`div_${field.Datatype}_${field.Id}`}
          style={{ display: 'flex', alignItems: 'center', gap: '24px', height: '56px' }} // 56px matches Ontario button height
        >
          {/* Main action button */}
          <ButtonComponent
            field={field}
            editable={true}
            isEng={this.props.isEng}
            title={title}
            labelControlArray={labelControlArray}
            requiredField={requiredField}
            callback={this.props.callbackElement}
            callbackStepIndex={this.props.callbackStepIndex}
          />

          {/* Cancel and exit button */}
          <button
            type="button"
            aria-label={this.props.isEng ? "Cancel and exit" : "Annuler et quitter"}
            onClick={() => {
              window.location.href = `${getEnvVar('BXP_UI_BASE_PATH')}/integration?redirectId=p13838394`;
            }}
            className="ontario-button"
            style={{
              background: "none",
              border: "none",
              padding: "0 24px",
              fontSize: "18px",
              color: "#0055C0",
              cursor: "pointer",
              textDecoration: "underline",
              height: '56px',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            {this.props.isEng ? "Cancel and exit" : "Annuler et quitter"}
          </button>
        </div>
      );
    }
    return controlArray;
  }
}